module.exports = __webpack_public_path__ + "static/media/WS2@2x.f3984e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WS/WS2@2x.png
// module id = 749
// module chunks = 0